export const navigateTo = url => {
  window.location.href = url
}
